import { api } from "./client";

// Смяна на СОБСТВЕНИТЕ парола и код от профилното меню
// (BE `app/external/users/router_credentials.py`). Отказите идват с
// локализиран `detail` ({bg, en}) и различен статус, по който формата решава
// под кое поле да покаже грешката: 400 — грешна текуща стойност, 409 — зает
// код, 403 — деактивиран акаунт (6 грешни опита за 24 ч., общ брояч с входа).

export async function changeOwnPassword(
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  await api.post("/user/change-password", {
    current_password: currentPassword,
    new_password: newPassword,
  });
}

export async function changeOwnCode(
  currentCode: string,
  newCode: string,
): Promise<void> {
  await api.post("/user/change-code", {
    current_code: currentCode,
    new_code: newCode,
  });
}
